import React from 'react'
import './Loader.scss'

const Loader = () =>  <div className="Loader"><div></div><div></div><div></div><div></div></div>

export default Loader
